// assets/promo-copy.js
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".koshe-copy-btn");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const code = btn.getAttribute("data-code");
      navigator.clipboard.writeText(code);

      const icon = btn.querySelector(".copy-icon");
      const text = btn.querySelector(".copy-text");

      // Change icon and text on click
      icon.textContent = "✔";
      text.textContent = "Copied!";

      // Reset after 2 seconds
      setTimeout(() => {
        icon.textContent = "📋";
        text.textContent = "Copy";
      }, 2000);
    });
  });
});
